import Parse from 'parse';
import serverConfig from './config/backend/server';

Parse.initialize(serverConfig[process.env.NODE_ENV].appId, null);
Parse.serverURL = serverConfig[process.env.NODE_ENV].url;
Parse.enableLocalDatastore();

export default Parse;
